<script lang="ts">
  import { changeQueryParam } from '$lib/navigation';
  import TokenGrid from '$lib/components/TokenGrid.svelte';
  import { _ITEMS_RENDERED } from './+page';
  import type { PageData } from './$types';
  import { setupReload } from '$lib/api';
  import ProfileHeadMeta from '$lib/components/ProfileHeadMeta.svelte';
  import { page } from '$app/stores';
  import { browser } from '$app/environment';

  export let data: PageData;

  $: ({ profile, tokens, addresses, currentPage, dependencies } = data);

  $: hasNext = tokens?.length === _ITEMS_RENDERED;

  setupReload(() => dependencies, {
    shouldReloadWithBackoff: () => !tokens,
    backoffStartInterval: 2000,
  });

  async function changePage({ detail: page }: { detail: number }) {
    if (browser) {
      await changeQueryParam('page', page);
      window.scrollTo(0, 0);
    }
  }
</script>

<svelte:head>
  {#if profile}
    <title>@{profile.username} | Bitski</title>

    <ProfileHeadMeta {profile} />
  {:else}
    <title>Bitski</title>
  {/if}
</svelte:head>

{#if addresses || (profile && $page.data.username === profile.username)}
  <TokenGrid {tokens} {currentPage} {hasNext} on:change={changePage} />
{:else}
  <div class="flex flex-col flex-grow justify-center p-12">
    <div class="text-center text-grey body-bold">
      <i class="emoji-sunglasses emoji-size" />
      <br />
      Account is private
    </div>
  </div>
{/if}

<style lang="postcss">
  .emoji-size {
    height: 1.563rem !important;
    width: 1.563rem !important;
  }
</style>
